"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettingPasswordEditor = void 0;
/* eslint-disable react/jsx-no-bind */
const react_1 = __importStar(require("react"));
const core_1 = require("@material-ui/core");
const react_hook_form_1 = require("react-hook-form");
const CreateOutlined_1 = __importDefault(require("@material-ui/icons/CreateOutlined"));
const SettingPasswordEditor = (props) => {
    const { description, handleValueChange } = props;
    const [isOpen, setIsOpen] = react_1.useState(false);
    const [isProcessing, setIsProcessing] = react_1.useState(false);
    const { handleSubmit, register, errors, getValues } = react_hook_form_1.useForm();
    console.log({ errors });
    const submit = async (e) => {
        setIsProcessing(true);
        await handleSubmit(async (data) => {
            if (handleValueChange) {
                await handleValueChange(data.passwordOld, data.passwordNew);
            }
            setIsOpen(false);
            setIsProcessing(false);
        }, () => {
            setIsProcessing(false);
        })(e);
    };
    return (react_1.default.createElement("div", null,
        react_1.default.createElement(core_1.Dialog, { open: isOpen, onClose: () => setIsOpen(false), disableBackdropClick: true, disableEscapeKeyDown: true, maxWidth: "xs", fullWidth: true },
            react_1.default.createElement(core_1.DialogTitle, null, "Edit password"),
            react_1.default.createElement(core_1.DialogContent, { dividers: true },
                description && react_1.default.createElement(core_1.DialogContentText, null, description),
                react_1.default.createElement("form", { onSubmit: submit },
                    react_1.default.createElement("p", null,
                        react_1.default.createElement(core_1.TextField, { label: "Old password", name: "passwordOld", type: "password", inputRef: register({ required: true }), fullWidth: true, disabled: isProcessing, error: errors.passwordOld, helperText: errors.passwordOld && errors.passwordOld.message })),
                    react_1.default.createElement("p", null,
                        react_1.default.createElement(core_1.TextField, { label: "New password", name: "passwordNew", type: "password", inputRef: register({ required: true, minLength: 5, maxLength: 128 }), fullWidth: true, error: errors.passwordNew, helperText: errors.passwordNew && errors.passwordNew.message, disabled: isProcessing })),
                    react_1.default.createElement("p", null,
                        react_1.default.createElement(core_1.TextField, { label: "Repeat new password", name: "passwordNew2", type: "password", inputRef: register({
                                required: true,
                                validate: (v) => v === getValues().passwordNew || 'New passwords must match'
                            }), fullWidth: true, error: errors.passwordNew2, helperText: errors.passwordNew2 && errors.passwordNew2.message, disabled: isProcessing })))),
            react_1.default.createElement(core_1.DialogActions, null,
                react_1.default.createElement(core_1.Button, { onClick: () => setIsOpen(false), color: "primary", disabled: isProcessing }, "Cancel"),
                react_1.default.createElement(core_1.Button, { onClick: submit, color: "primary", disabled: isProcessing }, "Save")),
            react_1.default.createElement(core_1.LinearProgress, { style: { visibility: isProcessing ? 'inherit' : 'hidden' } })),
        react_1.default.createElement(core_1.Grid, { container: true, justify: "space-between", alignItems: "center", onClick: () => setIsOpen(true), style: { cursor: 'pointer' } },
            react_1.default.createElement(core_1.Grid, { item: true },
                react_1.default.createElement(core_1.Typography, { display: "block", variant: "caption", color: "textSecondary" }, "Password"),
                react_1.default.createElement(core_1.Typography, { display: "block" }, "\u25CF\u25CF\u25CF\u25CF\u25CF\u25CF\u25CF\u25CF\u25CF\u25CF")),
            react_1.default.createElement(core_1.Grid, { item: true },
                react_1.default.createElement(core_1.IconButton, { onClick: () => setIsOpen(true) },
                    react_1.default.createElement(CreateOutlined_1.default, null))))));
};
exports.SettingPasswordEditor = SettingPasswordEditor;
//# sourceMappingURL=index.js.map